"use client"


import { Control, Controller, FieldErrors, UseFormRegister } from "react-hook-form";
import FileUploadInput from "../../input/MultipleFileUploadInput";
import { useDictionary } from "@/core/hooks/use-dictionary";
import { MultilingualInput, MultilingualTextareaInput } from "../GlobalWidgetEditor";
import LinkSelector from "../../LinkSelector";
import { Label } from "@/components/ui/label";

interface BannerWidgetProps {
    widgetIndex: number;
    name: string;
    control: Control<any>;
    register: UseFormRegister<any>;
    errors: FieldErrors<any>;
    disabled?: boolean;
}

export const BannerWidget = ({
    widgetIndex,
    name,
    control,
    register,
    errors,
    disabled,
}: BannerWidgetProps) => {
    const { dictionary } = useDictionary();

    const getError = (path: string) => {
        const errorPath = path.split('.');
        let current = errors;
        for (const key of errorPath) {
            if (current && typeof key === 'string' && key in current) {
                current = (current as any)[key];
            } else {
                return undefined;
            }
        }
        return (current as any)?.message;
    };

    const imageError = getError(`${name}.${widgetIndex}.image`) as string | undefined;

    return (
        <div className="space-y-4">
            {/* <div className="col-span-12 space-y-4"> */}
            <Controller
                control={control}
                name={`${name}.${widgetIndex}.image`}
                render={({ field }) => (
                    <FileUploadInput
                        accept="image/*"
                        disabled={disabled}
                        onUploadSuccess={(image) => {
                            if (!Array.isArray(image) && image) field.onChange(image);
                        }}
                        defaultImages={
                            field.value
                                ? [
                                    {
                                        ...field.value,
                                        name: field.value.name || '',
                                        description: field.value.description || '',
                                    },
                                ]
                                : []
                        }
                        onDefaultRemove={() => field.onChange(undefined)}
                        error={imageError}
                    />
                )}
            />
            <MultilingualInput
                baseName={`${name}.${widgetIndex}.title`}
                label={dictionary.forms?.title}
                register={register}
                errors={errors}
                disabled={disabled}
            />
            <MultilingualInput
                baseName={`${name}.${widgetIndex}.subtitle`}
                label={dictionary.forms?.subtitle}
                register={register}
                errors={errors}
                disabled={disabled}
            />
            <MultilingualTextareaInput
                baseName={`${name}.${widgetIndex}.description`}
                label={dictionary.forms?.description}
                register={register}
                errors={errors}
                disabled={disabled}
            />
            <MultilingualInput
                baseName={`${name}.${widgetIndex}.buttonContent`}
                label={dictionary.forms?.buttonContent}
                register={register}
                errors={errors}
                disabled={disabled}
            />
            <div className="space-y-1">
                <Label className="text-xs font-medium text-muted-foreground">
                    {dictionary.forms?.link}
                </Label>
                <Controller
                    control={control}
                    name={`${name}.${widgetIndex}.link`}
                    render={({ field: linkField }) => (
                        <LinkSelector
                            value={linkField.value || ''}
                            onChange={linkField.onChange}
                            placeholder={dictionary.forms?.link}
                        />
                    )}
                />
            </div>
        </div >
    );
};